export default __webpack_public_path__ + "static/media/mansion3.db88f33c.jpeg";